import { Link } from 'react-router-dom';
import { BookOpen, Lock, Play } from 'lucide-react';

const FALLBACK_THUMB = 'https://images.unsplash.com/photo-1713652492101-4705c38e9b58?crop=entropy&cs=srgb&fm=jpg&q=85&w=600';

// Compact course tile for the landing-page hero (HeroWithCourses): thumbnail,
// admin-set course number, FREE/PREMIUM badge, lesson count.
export default function CourseMiniCard({ course, number }) {
  const isFree = !!course.is_free;
  return (
    <Link
      to={`/courses/${course.id}`}
      className="group flex flex-col bg-white dark:bg-[#111] border border-gray-200 dark:border-white/10 shadow-sm hover:shadow-md hover:border-[#A67C52] transition-all overflow-hidden"
      data-testid={`hero-course-${course.id}`}
    >
      <div className="relative aspect-video overflow-hidden bg-gray-100 dark:bg-white/5">
        <img
          src={course.thumbnail_url || FALLBACK_THUMB}
          alt={course.title}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 bg-black/75 text-white text-[10px] font-bold px-2 py-0.5 tracking-wider">
          #{number}
        </span>
        <span
          className={`absolute top-2 right-2 text-[10px] font-bold px-2 py-0.5 tracking-wider flex items-center gap-1 ${
            isFree ? 'bg-green-600 text-white' : 'bg-[#A67C52] text-white'
          }`}
        >
          {isFree ? <Play className="w-3 h-3" /> : <Lock className="w-3 h-3" />}
          {isFree ? 'FREE' : 'PREMIUM'}
        </span>
      </div>
      <div className="p-2.5 flex-1 flex flex-col">
        <p className="text-xs sm:text-sm font-bold leading-snug text-[#2D2D2D] dark:text-white line-clamp-2">
          {course.title}
        </p>
        {course.lesson_count > 0 && (
          <p className="mt-auto pt-1.5 text-[11px] text-gray-500 dark:text-gray-400 flex items-center gap-1">
            <BookOpen className="w-3 h-3" /> {course.lesson_count} lessons
          </p>
        )}
      </div>
    </Link>
  );
}
